<div class="fx-bonus-setting  text-white mb-3">
  <div class="card-body">
    <form class="form form-horizontal" #form="ngForm" (ngSubmit)="onSubmitSetting()">
      <div class="row mb-3">
        <div class="col-lg-2 col-12 fs-18 font-bold">Bonus On Deposit</div>
        <div class="col-lg-10 col-12">
          <div class="row mb-3">
            <div class="col-auto">
              <div class="switch">
                <span class="mr-1">OFF</span>
                <mat-slide-toggle class="main text-green" [checked]="data.deposit.mode === 1 ? true : false"
                  (change)="data.deposit.mode = $event.checked ? 1 : 0"
                  [disabled]="!permission.allowCreating">ON</mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12 mb-3">
              <div class="label fs-16">Date</div>
            </div>
            <div class="col-lg col-12 mb-3">
              <div class="row">
                <div class="col-auto">
                  <div>Start Time</div>
                  <p-calendar [(ngModel)]="data.deposit.start_time" name="depositStart"
                    [placeholder]="'dd/mm/yyyy HH:mm'" [dateFormat]="'dd/mm/yy'" [timeOnly]="false" [showIcon]="true"
                    [showTime]="true" [disabled]="!permission.allowCreating"></p-calendar>
                  <span class="calender-time"></span>
                </div>
                <div class="col-auto">
                  <div>End Time</div>
                  <p-calendar [(ngModel)]="data.deposit.end_time" name="depositEnd" [placeholder]="'dd/mm/yyyy HH:mm'"
                    [dateFormat]="'dd/mm/yy'" [timeOnly]="false" [showIcon]="true" [showTime]="true"
                    [disabled]="!permission.allowCreating"></p-calendar>
                  <span class="calender-time"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Amount Conditions</div>
            </div>
            <div class="col-lg col-12">
              <div class="row mb-3" *ngFor="let con of data.deposit.conditions; let i = index">
                <div class="col-12">
                  <div class="label m-auto">Condition {{ i + 1 }}</div>
                </div>
                <div class="col-md-auto col-4">
                  <div class="input-group dark">
                    <input class="form-control bg-dark" type="number" name="deposit_threshold{{ i }}"
                      [disabled]="!permission.allowCreating" (keyup)="onUpdateRateUJ('conditions', i)"
                      [(ngModel)]="con.threshold" />
                    <span class="input-group-text">¥</span>
                  </div>
                </div>
                <div class="col-md-auto col-4">
                  <div class="input-group disabled">
                    <input class="form-control" type="number" name="view_threshold{{ i }}" [disabled]="true"
                      [value]="viewBonus.conditions[i].threshold" />
                    <span class="input-group-text">$</span>
                  </div>
                </div>
                <div class="col-md-auto col-4">
                  <div class="input-group dark">
                    <input class="form-control bg-dark" type="number" [(ngModel)]="con.rate" name="deposit_rate{{ i }}"
                      [disabled]="!permission.allowCreating" />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Upper Limit</div>
            </div>
          
           
            <div class="col-md-auto col-4">
              <div class="input-group dark">
                <input class="form-control bg-dark" type="number" [disabled]="!permission.allowCreating"
                  (keyup)="onUpdateRateUJ('up_limit_usd', 0)" [(ngModel)]="data.deposit.up_limit"
                  name="depositUpLimit" />
                <span class="input-group-text">¥</span>
              </div>
            </div>
            <div class="col-md-auto col-4">
              <div class="input-group disabled">
                <input type="number" name="depositUpLimitUSD" class="form-control" placeholder="ex:10" [disabled]="true"
                  [value]="viewBonus.up_limit_usd" required />
                <span class="input-group-text">$</span>
              </div>
            </div>
            <div class="col-md-auto col-4 position-relative">
              <div class="pc-label">Start Time</div>
              <p-calendar
                name="up_limit_start_time"
                [(ngModel)]="data.deposit.up_limit_start_time"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [timeOnly]="false"
                [showIcon]="true"
                [showTime]="true"
                inputStyleClass="form-control"
                required
              ></p-calendar>
              <span class="calender-time"></span>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Bonus Timeout</div>
            </div>
            <div class="col-md-auto">
              <div class="input-group dark">
                <select name="dfw" [(ngModel)]="data.deposit.bonus_timeout" required>
                <option [ngValue]="item" *ngFor="let item of dfws">{{item}}</option>
              </select>
              </div>
            </div>

          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Multiple</div>
            </div>

            <div class="col-md-auto col-12">
              <div class="row">
                <div class="col-auto">
                  <div class="switch">
                    <span class="mr-1">OFF</span>
                    <mat-slide-toggle
                    class="main text-green"
                    [checked]="data.deposit.multiple_time"
                    (change)="data.deposit.multiple_time = $event.checked"
                    [disabled]="!permission.allowCreating"
                    >ON</mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Bonus Type</div>
            </div>
            <div class="col-md-auto col-4" >
              <div class="input-group dark">
                <select name="bonusType" [(ngModel)]="data.deposit.bonus_type">
                  <option [ngValue]=0>Normal</option>
                  <option [ngValue]=1>Before</option>
                  <option [ngValue]=2>After</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="data.deposit.mode === 1">
            <div class="col-lg-auto col-12">
              <div class="label fs-16">Comment </div>
            </div>
            <div class="col-md-auto col-4">
              <div class="input-group dark">
                <input class="form-control bg-dark" name="deposit_comment" type="text"
                   required [(ngModel)]="data.deposit.comment" />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row mb-20">
        <div class="col-lg-2 col-12 fs-18 font-bold">Bonus On Open Account</div>
        <div class="col-lg-10 col-12">
          <div class="mb-3 row">
            <div class="col-auto">
              <div class="switch">
                <span class="mr-1">OFF</span>
                <mat-slide-toggle
                  class="main text-green"
                  [checked]="data.open_account.mode == 1 ? true : false"
                  (change)="data.open_account.mode = $event.checked ? 1 : 0"
                  [disabled]="!permission.allowCreating"
                  >ON</mat-slide-toggle
                >
              </div>
            </div>
          </div>
          <ng-container *ngIf="data.open_account.mode == 1">
            <div class="mb-3 row" *ngIf="type === 'permanent_bonus_ib'">
              <div class="col-lg-auto col-12">
                <div class="label fs-16">Apply to IB Account</div>
              </div>
              <div class="col-md-auto col-4">
                <div class="switch">
                  <span class="mr-1">OFF</span>
                  <mat-slide-toggle
                    class="main text-green"
                    [checked]="data.open_account.ib_apply === 1"
                    (change)="data.open_account.ib_apply = $event.checked ? 1 : 0"
                    [disabled]="!permission.allowCreating"
                  >ON</mat-slide-toggle>
                </div>
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-lg-auto col-12">
                <div class="label fs-16">Amount Conditions</div>
              </div>
              <div class="col-md-auto col-4">
                <div class="input-group dark">
                  <input
                    onpaste="return false"
                    class="form-control bg-dark"
                    type="number"
                    name="openAccountJPY"
                    required
                    pattern="^(?!(?:[^\d\r\n]*\d){11})\d+(?:\.\d+)?$"
                    [disabled]="!permission.allowCreating"
                    [(ngModel)]="data.open_account.jpy_bonus"
                  />
                  <span class="input-group-text">¥</span>
                </div>
              </div>
              <div class="col-md-auto col-4">
                <div class="input-group dark">
                  <input
                    onpaste="return false"
                    required
                    class="form-control bg-dark"
                    type="number"
                    pattern="^(?!(?:[^\d\r\n]*\d){11})\d+(?:\.\d+)?$"
                    name="openAccountUSD"
                    [disabled]="!permission.allowCreating"
                    [(ngModel)]="data.open_account.usd_bonus"
                  />
                  <span class="input-group-text">$</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-auto col-12 mb-3">
                <div class="label fs-16">Date</div>
              </div>
              <div class="col-lg col-12 mb-3">
                <div class="row">
                  <div class="col-auto">
                    <div>Start Time</div>
                    <p-calendar
                      [(ngModel)]="data.open_account.start_time"
                      name="accountStart"
                      [placeholder]="'dd/mm/yyyy HH:mm'"
                      [dateFormat]="'dd/mm/yy'"
                      [showIcon]="true"
                      [showTime]="true"
                      [disabled]="!permission.allowCreating"
                    ></p-calendar>
                    <span class="calender-time"></span>
                  </div>
                  <div class="col-auto">
                    <div>End Time</div>
                    <p-calendar
                      [(ngModel)]="data.open_account.end_time"
                      (onShow)="onConvertDate($event)"
                      name="accountEnd"
                      [placeholder]="'dd/mm/yyyy HH:mm'"
                      [dateFormat]="'dd/mm/yy'"
                      [showIcon]="true"
                      [showTime]="true"
                      [disabled]="!permission.allowCreating"
                    ></p-calendar>
                    <span class="calender-time"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-lg-auto col-12">
                <div class="label fs-16">Comment</div>
              </div>
              <div class="col-md-auto col-12">
                <div class="input-group dark">
                  <input
                    onpaste="return false"
                    class="form-control bg-dark"
                    type="text"
                    name="account_comment"
                    required
                    [disabled]="!permission.allowCreating"
                    [(ngModel)]="data.open_account.comment"
                  />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
        <hr edit-permission />
        <div class="row">
          <div class="col-md-12 col-xs-12" edit-permission>
            <button type="submit" class="btn btn-main pull-right btn-bonus-apply">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>